// src/config/media.js – ONE place for every image and video, grouped by section.
import { cldUrl, cldPoster } from "./cloudinary";
import { mediaSrc, posterSrc } from "../utils/media";

const img = (acc, id, label = "") => ({ acc, type: "image", id, label, url: cldUrl({ acc, type: "image", id }) });
const vid = (acc, id, label = "") => ({ acc, type: "video", id, label, url: cldUrl({ acc, type: "video", id }) });

// Verified migrated theme decor photos on Account 4
const THEME_PHOTOS = [
  img(4, "carnival/themes/theme-royal-hall.jpg", "Royal Hall Theme"),
  img(4, "carnival/themes/theme-fairy-lights.jpg", "Fairy Lights Theme"),
  img(4, "carnival/themes/theme-grand-balloon.jpg", "Grand Balloon Theme"),
  img(4, "carnival/themes/theme-romantic-canopy.jpg", "Romantic Canopy Theme"),
  img(4, "carnival/themes/theme-neon-celebration.jpg", "Neon Celebration Theme"),
  img(4, "carnival/themes/theme-vintage-classic.jpg", "Vintage Classic Theme"),
];

const kidsBirthday = vid(3, "carnival/occasions/kids/kids-birthday-celebration.mp4", "Kids Birthday Celebration Party");
const littleBundleOfJoy = vid(3, "carnival/occasions/kids/little-bundle-of-joy-svojass.mp4", "Little Bundle of Joy Svojass");
const carEntry = vid(3, "carnival/occasions/kids/kids-car-entry.mp4", "Kids VIP Car Entry Celebration");
const ayanshBirthday = vid(3, "carnival/occasions/birthday/ayansh-birthday-celebration.mp4", "Ayansh 1st Birthday Cake Smash");
const angelDhanvika = vid(3, "carnival/occasions/birthday/angel-dhanvika-birthday.mp4", "Angel Dhanvika Birthday Celebration");
const privateTheatres = vid(3, "carnival/occasions/movie-preview/private-theatres-experience.mp4", "Private Theatres Experience Walkthrough");

// Verified migrated celebration videos on Account 3
const OCCASION_VIDEOS = {
  kidsBirthday,
  littleBundleOfJoy,
  carEntry,
  ayanshBirthday,
  angelDhanvika,
  privateTheatres,
  kids: [kidsBirthday, littleBundleOfJoy, carEntry],
  birthday: [ayanshBirthday, angelDhanvika],
  moviePreview: [privateTheatres],
};

export const MEDIA = {
  home: {
    heroVideo: vid(2, "carnival/home/hero/carnival-castle-hero.mp4", "Carnival Castle private theatres"),
    banners: [
      img(2, "carnival/home/banners/banner-1.png", "Carnival Castle Banner 1"),
    ],
    offers: [],
  },
  reels: [],
  testimonials: [],
  themes: THEME_PHOTOS,
  occasions: OCCASION_VIDEOS,
  catalog: {
    cakes: [],
    food: [img(4, "carnival/food/food-and-beverages.jpg", "Food and Beverages")],
    bouquets: [img(4, "carnival/bouquets/roses-bouquet.jpg", "Rose Bouquet")],
    theatres: [img(4, "carnival/theatres/private-screening-theatre.jpg", "Private Screening Theatre")],
    addons: [],
  },
  gallery: [],
  blogs: {},
  brand: {},
};

export const mediaUrl = (item, opts) => {
  if (!item) return "";
  if (typeof item === "string") return mediaSrc(item, opts);
  return item?.url ? mediaSrc(item.url, opts) : cldUrl(item, opts);
};

export const posterUrl = (item, w) => {
  if (!item) return "";
  if (typeof item === "string") return posterSrc(item, w);
  return item?.url ? posterSrc(item.url, w) : cldPoster(item, w);
};

export default MEDIA;
